export default __webpack_public_path__ + "static/media/gi-card-img1.3509b2ff.png";